import { render } from "./WordLookupPopover.vue?vue&type=template&id=6dfd40ba&scoped=true"
import script from "./WordLookupPopover.vue?vue&type=script&lang=js"
export * from "./WordLookupPopover.vue?vue&type=script&lang=js"

import "./WordLookupPopover.vue?vue&type=style&index=0&id=6dfd40ba&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfd40ba"]])

export default __exports__